/**
 * Use this function in your default switch case to assert that this code is never reached. I.e. the switch statement is exhaustive.
 */
export function assertUnreachableDefaultCase(type: never): never {
	throw new Error(`Unhandled case with value: ${type}`);
}
